<template lang="pug">
  div
    sidebar
      transition-group.group-list(
        name="list-complete",
        mode="out-in",
        tag="ul")
        template(v-if="menuAuth.includes('top')")
          li.list-complete-item(v-if="summary.common_policy" key="function-settings")
            router-link.group-link(:to="{name: 'function-settings'}")
              span {{$t('function-settings')}}
          li.list-complete-item(v-if="summary.ip_policy" key="blocking-settings")
            router-link.group-link(:to="{name: 'blocking-settings'}")
              span {{$t('blocking-settings')}}

        li.list-complete-item.li-head(v-if="menuAuth.includes('manager')" key="1")
          icon(name="caret-down")
          span {{$t('management_page.manager_management')}}
          ul
            li.list-complete-item(v-if="menuAuth.includes('manager-integrated')" key="11")
              router-link.group-link(:to="{name: 'manager-integrated'}")
                span {{$t('management_page.integration_management')}}
            li.list-complete-item(v-if="menuAuth.includes('manager-approval')" key="12")
              router-link.group-link(:to="{name: 'manager-approval'}")
                span {{$t('management_page.registration_request_approval')}}
            li.list-complete-item(v-if="menuAuth.includes('manager-applyHistory')" key="13")
              router-link.group-link(:to="{name: 'manager-applyHistory'}")
                span {{$t('management_page.registration_request_history')}}
            li.list-complete-item(v-if="menuAuth.includes('manager-regDelHistory')" key="14")
              router-link.group-link(:to="{name: 'manager-regDelHistory'}")
                span {{$t('management_page.registration_deletion_history')}}

        li.list-complete-item.li-head(v-if="menuAuth.includes('agent-regDelHistory')" key="2")
          icon(name="caret-down")
          span {{$t('remote_device')}} {{$t('manage')}}
          ul
            li.list-complete-item(v-if="menuAuth.includes('agent-integrated')" key="21")
              router-link.group-link(:to="{name: 'agent-integrated'}")
                span {{$t('management_page.integration_management')}}
            li.list-complete-item(v-if="menuAuth.includes('agent-approval')" key="22")
              router-link.group-link(:to="{name: 'agent-approval'}")
                span {{$t('management_page.registration_request_approval')}}
            li.list-complete-item(v-if="menuAuth.includes('agent-applyHistory')" key="23")
              router-link.group-link(:to="{name: 'agent-applyHistory'}")
                span {{$t('management_page.registration_request_history')}}
            li.list-complete-item(v-if="menuAuth.includes('agent-regDelHistory')" key="24")
              router-link.group-link(:to="{name: 'agent-regDelHistory'}")
                span {{$t('management_page.registration_deletion_history')}}

        li.list-complete-item.li-head(v-if="menuAuth.includes('userRemote')" key="3")
          icon(name="caret-down")
          span {{$t('management_page.user_remote')}}
          ul
            li.list-complete-item(v-if="menuAuth.includes('userRemote-approval')" key="31")
              router-link.group-link(:to="{name: 'userRemote-approval'}")
                span {{$t('management_page.remote_request_approval')}}
            li.list-complete-item(v-if="menuAuth.includes('userRemote-history')" key="32")
              router-link.group-link(:to="{name: 'userRemote-history'}")
                span {{$t('management_page.remote_request_history')}}
            li.list-complete-item(v-if="menuAuth.includes('userRemote-controlHistory')" key="33")
              router-link.group-link(:to="{name: 'userRemote-controlHistory'}")
                span {{$t('management_page.remote_control_history')}}
            li.list-complete-item(v-if="menuAuth.includes('userRemote-controlHistory-self')" key="34")
              router-link.group-link(:to="{name: 'userRemote-controlHistory-self'}")
                span {{$t('management_page.remote_control_history_self')}}
    div.lmm-content-body
      router-view
</template>

<script>
import Sidebar from "../mixins/sidebar"
import store from "@/api/store"
import { user } from "@/api/access"

export default {
  name: "manage-component",
  components: { sidebar: Sidebar },
  computed: {
    networkType() {
      return store.get("networkType")
    },
    accountType() {
      return store.get('auth').account_type
    },
    menuAuth() {
      const userInfo = user()
      const isExternal = this.networkType.indexOf("e") === 0
      const isCorporate = this.accountType === 1
      const role = userInfo.type
      
      const menus = {
        corporate: {
          internal: {
            Member: [],
            SubManager: [
              'manager',
              'manager-approval',
              'manager-applyHistory',
              'manager-regDelHistory',
              'agent',
              'agent-approval',
              'agent-applyHistory',
              'agent-regDelHistory',
              'userRemote',
              'userRemote-approval',
              'userRemote-history',
              'userRemote-controlHistory',
              'userRemote-controlHistory-self',
            ],
            Manager: [
              'top',
              'policy-management',
              'ip-management',
              'manager',
              'manager-integrated',
              'manager-approval',
              'manager-applyHistory',
              'manager-regDelHistory',
              'agent',
              'agent-integrated',
              'agent-approval',
              'agent-applyHistory',
              'agent-regDelHistory',
              'userRemote',
              'userRemote-approval',
              'userRemote-history',
              'userRemote-controlHistory',
              'userRemote-controlHistory-self',
            ],
          },
          external: {
            Member: ['userRemote', 'userRemote-history', 'userRemote-controlHistory-self'],
            SubManager: ['userRemote', 'userRemote-history', 'userRemote-controlHistory-self'],
            Manager: ['userRemote', 'userRemote-history', 'userRemote-controlHistory-self'],
          },
        },
        personal: {
          internal: {
            Member: [],
            SubManager: [],
            Manager: ['top', 'policy-management', 'ip-management'],
          },
          external: {
            Member: ['userRemote', 'userRemote-controlHistory-self'],
            SubManager: ['userRemote', 'userRemote-controlHistory-self'],
            Manager: ['userRemote', 'userRemote-history', 'userRemote-controlHistory-self'],
          },
        },
      }
      
      const groupType = isCorporate ? 'corporate' : 'personal'
      const networkType = isExternal ? 'external' : 'internal'
      
      // 기본 메뉴 설정
      let menuArray = menus[groupType][networkType][role] || []
      
      // 내부망에서 정책 관리 또는 IP 정책 관련 권한이 없는 경우 메뉴에서 제거
      if (!isExternal) {
        if (!this.summary.common_policy) {
          menuArray = menuArray.filter(menu => menu !== 'policy-management');
        }
        if (!this.summary.ip_policy) {
          menuArray = menuArray.filter(menu => menu !== 'ip-management');
        }
      }
      
      return menuArray
    },
  },
  methods: {
    getUserData() {
      let stored = store.get("summary")
      this.summary = stored
    },
  },
  created() {
    this.getUserData()
  },
  data() {
    return {
      summary: {},
      user: user(),
    }
  },
}
</script>
